import React, { createContext, useContext, useState, ReactNode } from 'react';
import Recap from 'shared/components/Recap/Recap';

interface RecapContextType {
  isRecapActive: boolean;
  appointmentId: string | null;
  toggleRecap: () => void;
  setRecapAppointmentId: (id: string | null) => void;
}

const RecapContext = createContext<RecapContextType | undefined>(undefined);

export const RecapProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isRecapActive, setIsRecapActive] = useState(false);
  const [appointmentId, setAppointmentId] = useState<string | null>(null);

  const toggleRecap = (): void => setIsRecapActive((prev) => !prev);
  const setRecapAppointmentId = (id: string | null): void => setAppointmentId(id);

  return (
    <RecapContext.Provider value={{ isRecapActive, appointmentId, toggleRecap, setRecapAppointmentId }}>
      {appointmentId && isRecapActive && <Recap appointmentId={appointmentId} />}
      {children}
    </RecapContext.Provider>
  );
};

export const useRecap = (): RecapContextType => {
  const context = useContext(RecapContext);
  if (!context) {
    throw new Error('useRecap must be used within a RecapProvider');
  }
  return context;
};
